import { gmRequest } from './';

export default {
  logView: (profileId, mediaID) =>
    gmRequest(`/api/v1/profile/${profileId}/media/${mediaID}/views`, { method: 'PATCH' }),
};
